
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiButtonVessel as ObcPoiButtonVesselElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-button-vessel/poi-button-vessel.js';
 
 
 

 
 export const ObcPoiButtonVessel = createComponent({
   react: React,
   tagName: 'obc-poi-button-vessel',
   elementClass: ObcPoiButtonVesselElement,
   events: {
     
   }
  });
 
 